<template>
  <div>
    <v-row class="d-flex align-center">
      <div class="circle"></div>
      <v-row>
        <div class="line"></div>
        <div class="line"></div>
      </v-row>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OneLine',
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .circle {
    border: transparent;
    padding: 15px;
    width: 1px;
    height: 12px;
    border-radius: 100%;
    animation: pulse 1s infinite ease-in-out;
    -webkit-animation: pulse 1s infinite ease-in-out;
  }
  .line {
    height: 12px;
    margin: 10px;
    width: 200px;
    animation: pulse 1s infinite ease-in-out;
    -webkit-animation: pulse 1s infinite ease-in-out;
  }

  @keyframes pulse {
    0% {
      background-color: rgba(165, 165, 165, .1);
    }
    50% {
      background-color: rgba(165, 165, 165, .3);
    }
    100% {
      background-color: rgba(165, 165, 165, .1);
    }
  }
  @-webkit-keyframes pulse {
    0% {
      background-color: rgba(165, 165, 165, .1);
    }
    50% {
      background-color: rgba(165, 165, 165, .3);
    }
    100% {
      background-color: rgba(165, 165, 165, .1);
    }
  }
</style>
